import { Breakdown as UiKitBreakdown } from "@xola/ui-kit";
import React, { ReactNode } from "react";
import { useLocalizationStore } from "@/stores/localizationStore";

interface BreakdownProps {
    children?: ReactNode;
    className?: string;
    currency: string;
}

export const Breakdown = (props: BreakdownProps) => {
    const locale = useLocalizationStore().getLocale();
    return (
        <UiKitBreakdown {...props} locale={locale}>
            {props.children}
        </UiKitBreakdown>
    );
};

// When using Breakdown.[something], always wrap it with <Breakdown>...</Breakdown>
// to ensure the currency is displayed in the correct format.
Breakdown.Item = UiKitBreakdown.Item;
Breakdown.SubtotalItem = UiKitBreakdown.SubtotalItem;
Breakdown.Separator = UiKitBreakdown.Separator;
